import { render, staticRenderFns } from "./TourVouchers.vue?vue&type=template&id=cad4f326"
import script from "./TourVouchers.vue?vue&type=script&lang=js"
export * from "./TourVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cad4f326')) {
      api.createRecord('cad4f326', component.options)
    } else {
      api.reload('cad4f326', component.options)
    }
    module.hot.accept("./TourVouchers.vue?vue&type=template&id=cad4f326", function () {
      api.rerender('cad4f326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourVouchers.vue"
export default component.exports